/**
 * Created by Jerker Nord on 2019-09-04.
 */
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {BonusBunniesParsedGameData} from "../server/data/BonusBunniesParsedGameData";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {IBonusBunniesInitData} from "../server/data/IBonusBunniesGameData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";

export class BonusBunniesSpinController extends SpinController {

    private static REELS_TO_SPIN_BONUS_GAME_DEFAULT:boolean[] = [true, true, true, true, false, true, true, true, true, false, true, true, true, true, false, true, true, true, true, false, false, false, false, false, false];
    private _reelsToSpinBonusGame:boolean[] = [true, true, true, true, false, true, true, true, true, false, true, true, true, true, false, true, true, true, true, false, false, false, false, false, false];
    private _reelsToSpinBaseGame:boolean[] = [true, true, true, true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false];
    private _isRestoreState:boolean;
    private _bottomRowActivated:boolean;
    private _lastReelActivated:boolean;

    constructor() {
        super();
    }

    protected parseGameData(data:BonusBunniesParsedGameData):void {
        this._isRestoreState = (data instanceof ParsedInitData) ? (<ParsedInitData>data).isRestoreState : false;
        let bonusValues:number[][] = data.bonusValuesAfterSpin;
        if(this._isRestoreState == true) {
            const initData:IBonusBunniesInitData = <IBonusBunniesInitData><unknown>data;
            this._bottomRowActivated = initData.bottomRowActivated;
            this._lastReelActivated = initData.lastReelActivated;
            this.setActiveReelsOnRestore(initData.bonusOverlaySymbols);
            bonusValues = data.bonusValuesBeforeSpin;
        }

        if(data.mode == BonusBunniesGameMode.BONUS_GAME || (this._isRestoreState && data.mode == BonusBunniesGameMode.BONUS_GAME)) {
            let currentReel:number;
            for(let i:number = 0; i < bonusValues.length; i++) {
                for(let j:number = 0; j < bonusValues[i].length; j++) {
                    currentReel = (i * 5) + j;
                    if(bonusValues[i][j] > 0) {
                        if(data.reels[currentReel][1] == "B") {
                            data.reels[currentReel][1] = "V";// + bonusValues[i][j];
                        }
                        if(data.reels[currentReel][1] == "B3") {
                            data.reels[currentReel][1] = "B3";// + bonusValues[i][j];
                        }
                    }
                }
            }
        }
    }

    protected getSpinTime():number {
        let spinTime:number = GameSetting.isFastSpin ? BonusBunniesGameConfig.instance.REEL_FAST_SPIN_SPIN_TIME : BonusBunniesGameConfig.instance.REEL_SPIN_TIME;
        if(this._mode == BonusBunniesGameMode.BONUS_GAME) {
            spinTime = GameSetting.isFastSpin ? BonusBunniesGameConfig.instance.REEL_FAST_SPIN_SPIN_TIME : BonusBunniesGameConfig.instance.REEL_SPIN_TIME_BONUS_GAME;
        }

        if(this._isZeroBet) {
            return spinTime;
        }

        return Math.max(spinTime, SpinController.MIN_SPIN_TIME);
    }

    private setActiveReelsOnRestore(stickyBonusPositions:string[][]):void {
        for(let i:number = 0; i < stickyBonusPositions.length; i++) {
            for(let j:number = 0; j < stickyBonusPositions[i].length; j++) {
                if(stickyBonusPositions[i][j].indexOf("B") > -1) {
                    this.disableBonusReel((i * 5) + j);
                } else {
                    this._reelsToSpinBonusGame[(i * 5) + j] = true;
                }
            }
        }
        if(this._bottomRowActivated == false) {
            this.disableLastBonusRow();
        }
        if(this._lastReelActivated == false) {
            this.disableLastBonusReel();
        }
    }

    protected getReelsGameConfigFromPreviousGameData():boolean[] {
        if(this._mode == BonusBunniesGameMode.BONUS_GAME || this._nextMode == BonusBunniesGameMode.BONUS_GAME) {
            return this._reelsToSpinBonusGame;
        } else {
            return this._reelsToSpinBaseGame;
        }
    }

    public resetBonusReelsToSpin():void {
        for(let i:number = 0; i < BonusBunniesSpinController.REELS_TO_SPIN_BONUS_GAME_DEFAULT.length; i++) {
            this._reelsToSpinBonusGame[i] = BonusBunniesSpinController.REELS_TO_SPIN_BONUS_GAME_DEFAULT[i];
        }
    }

    public disableBonusReel(reel:number):void {
        this._reelsToSpinBonusGame[reel] = false;
    }

    public enableLastBonusReel():void {
        this._reelsToSpinBonusGame[20] = true;
        this._reelsToSpinBonusGame[21] = true;
        this._reelsToSpinBonusGame[22] = true;
        this._reelsToSpinBonusGame[23] = true;
    }

    private disableLastBonusReel():void {
        this._reelsToSpinBonusGame[20] = false;
        this._reelsToSpinBonusGame[21] = false;
        this._reelsToSpinBonusGame[22] = false;
        this._reelsToSpinBonusGame[23] = false;
        this._reelsToSpinBonusGame[24] = false;
    }

    public enableLastBonusRow():void {
        this._reelsToSpinBonusGame[4] = true;
        this._reelsToSpinBonusGame[9] = true;
        this._reelsToSpinBonusGame[14] = true;
        this._reelsToSpinBonusGame[19] = true;
    }

    private disableLastBonusRow():void {
        this._reelsToSpinBonusGame[4] = false;
        this._reelsToSpinBonusGame[9] = false;
        this._reelsToSpinBonusGame[14] = false;
        this._reelsToSpinBonusGame[19] = false;
        this._reelsToSpinBonusGame[24] = false;
    }

    public enableLastBonusReelAndRow():void {
        this._reelsToSpinBonusGame[24] = true;
    }

    get reelsToSpinBonusGame():boolean[] {
        return this._reelsToSpinBonusGame;
    }

    public getNumberOfActiveReels():number {
        let reelCounter:number = 0;
        for(let i:number = 0; i < this._reelsToSpinBonusGame.length; i++) {
            if (this._reelsToSpinBonusGame[i] == true){
                reelCounter++;
            }
        }
        return reelCounter;
    }
}